import plaintext from './formatters/plaintext.js';
import html from './formatters/html.js';
import textarea from './formatters/textarea.js';
import money from './formatters/money.js';
import link from './formatters/link.js';
import image from './formatters/image.js';
import tickCross from './formatters/tickCross.js';
import datetime from './formatters/datetime.js';
import datetimediff from './formatters/datetimediff.js';
import lookup from './formatters/lookup.js';
import star from './formatters/star.js';
import traffic from './formatters/traffic.js';
import progress from './formatters/progress.js';
import color from './formatters/color.js';
import buttonTick from './formatters/buttonTick.js';
import buttonCross from './formatters/buttonCross.js';
import rownum from './formatters/rownum.js';
import handle from './formatters/handle.js';
import responsiveCollapse from './formatters/responsiveCollapse.js';
import rowSelection from './formatters/rowSelection.js';

export default {
	plaintext:plaintext,
	html:html,
	textarea:textarea,
	money:money,
	link:link,
	image:image,
	tickCross:tickCross,
	datetime:datetime,
	datetimediff:datetimediff,
	lookup:lookup,
	star:star,
	traffic:traffic,
	progress:progress,
	color:color,
	buttonTick:buttonTick,
	buttonCross:buttonCross,
	rownum:rownum,
	handle:handle,
	responsiveCollapse:responsiveCollapse,
	rowSelection:rowSelection,
};